<script setup lang="ts">
import SkeletonLoader from '@/components/base/skeleton/SkeletonLoader.vue'
</script>
<template>
  <div columns-2 gap-3 px-4 mt-10>
    <SkeletonLoader class="w-full h-40" mb-4 />
    <SkeletonLoader class="w-full h-40" mb-4 />
    <SkeletonLoader class="w-full h-50" mb-4 />
    <SkeletonLoader class="w-full h-30" mb-4 />
    <SkeletonLoader class="w-full h-40" mb-4 />
    <SkeletonLoader class="w-full h-30" mb-4 />
    <SkeletonLoader class="w-full h-50" mb-4 />
    <SkeletonLoader class="w-full h-60" mb-4 />
    <SkeletonLoader class="w-full h-40" mb-4 />
    <SkeletonLoader class="w-full h-60" mb-4 />
    <SkeletonLoader class="w-full h-50" mb-4 />
    <SkeletonLoader class="w-full h-50" mb-4 />
  </div>
</template>
<style lang="scss" scoped></style>
